import { JobStatusGuard } from './job-status.guard';

export const guards: any[] = [JobStatusGuard];

export * from './job-status.guard';
